import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetailsForm from "./sections/ContactDetailsForm";
import MapPlaceholder from "./sections/MapPlaceholder";
import AdditionalHelp from "./sections/AdditionalHelp";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactDetailsForm />
      <MapPlaceholder />
      <AdditionalHelp />
      <Footer />
    </div>;
}